import { useMutation } from '@tanstack/react-query';

import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { deleteUser } from '../../requests/deleteUser';

export const useDeleteUser = () => {
  const { constructDelete } = useRequestConstructor();

  const { mutateAsync: deleteUserById, ...rest } = useMutation({
    mutationFn: (uuid: string) => deleteUser(constructDelete, uuid),
    onSuccess: () => handleSuccess('User deleted.'),
    onError: () => handleError('Failed to delete user.'),
  });

  return { deleteUserById, ...rest };
};
